import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-breadcrumbs', 'title', 'Rīcības drupatas navigācija');
